// WelcomeDialog.jsx
const WelcomeDialog = ({ onClose }) => {
  return (
      <div className="space-y-6">
          <div>
              <p className="text-gray-600">
                  Welcome to Eden Interactive's C360 Platform - your collaborative space for 
                  defining project requirements.
              </p>
          </div>

          <div>
              <h3 className="text-lg font-medium mb-2">Team Questionnaire</h3>
              <p className="text-gray-600">
                  Start by completing our comprehensive questionnaire to help identify the 
                  features that matter most to your team. This collaborative approach ensures we 
                  capture all essential requirements while filtering out unnecessary components.
              </p>
          </div>

          <div>
              <h3 className="text-lg font-medium mb-2">Feature-by-Feature Assessment</h3>
              <p className="text-gray-600">
                  After the questionnaire, you'll review features individually with your team. Team 
                  members can ask questions, express requirements, and mark features as needed 
                  or not needed. This structured approach helps ensure nothing is overlooked.
              </p>
          </div>

          <div>
              <h3 className="text-lg font-medium mb-2">Collaborative Decision Making</h3>
              <p className="text-gray-600">
                  Work together with your team to make informed decisions about which features 
                  are essential for your project's success. The platform facilitates seamless 
                  communication and consensus-building.
              </p>
          </div>

          <div className="flex items-center justify-between pt-4">
              <label className="flex items-center text-sm text-gray-600">
                  <input 
                      type="checkbox" 
                      className="mr-2" 
                      onChange={(e) => {
                          if (e.target.checked) {
                              localStorage.setItem('hideWelcomeScreen', 'true');
                          } else {
                              localStorage.removeItem('hideWelcomeScreen');
                          }
                      }}
                  />
                  Don't show this again
              </label>
              <button
                  onClick={onClose}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                  Get Started
              </button>
          </div>
      </div>
  );
};

export default WelcomeDialog;